import { useDataChange } from 'Simple/Data.js'

export function useOnSave(props) {
  let change = useDataChange({
    context: 'form',
    viewPath: props.viewPath,
  })

  return function save(recipient_id, postal_address_id) {
    change(next => {
      next.action.recipient_id = recipient_id
      next.action.postal_address_id = postal_address_id
    })
  }
}

export function useOnClick(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'form',
    path: 'action',
  })
  return function onClick() {
    change({ id: null, document_template: null })
  }
}
